<div class="acc-order-details">
  <div class="row account-overview-header">
    <div class="col-xs-4 col-sm-5 col-md-7">
      <h3 class="orders">{{ 'accountOrders.title' | cxTranslate }}</h3>
    </div>
  </div>
  @if (!isLoadingDone) {
    <app-loader></app-loader>
  }
  @if (!!ordersList && ordersList.length === 0 && isLoadingDone) {
    <div
      class="text-center no-orders"
      >
      {{ 'accountOrders.no_orders_found' | cxTranslate }}
    </div>
  }

  @if (!!ordersList && ordersList.length > 0 && isLoadingDone) {
    <section
      class="payment-section"
      >
      <!--table starts-->
      <table
        aria-describedby="creditsTable"
        id="applyCreditsTable"
        class="credits-table table table-striped">
        <thead>
          <tr>
            <th
              scope="col"
              (click)="sortColumn($event, 'placed', ordersList, 'Date')">
              {{ 'accountOrders.date_label' | cxTranslate }}&nbsp;
              <em class="my-icon fas fa-caret-down"></em>
            </th>
            <th
              scope="col"
              (click)="sortColumn($event, 'code', ordersList, 'normal')">
              {{ 'accountOrders.order_no_label' | cxTranslate }}
              <em class="my-icon fas fa-caret-down"></em>
            </th>
            <th
              scope="col"
              (click)="sortColumn($event, 'status', ordersList, 'normal')">
              {{ 'accountOrders.order_status_label' | cxTranslate }}
              <em class="my-icon fas fa-caret-down"></em>
            </th>
            <th
              scope="col"
            (click)="
              sortColumn($event, 'purchaseOrderNumber', ordersList, 'normal')
            ">
              {{ 'accountOrders.order_po_num_label' | cxTranslate }}
              <em class="my-icon fas fa-caret-down"></em>
            </th>
            <th
              scope="col"
              (click)="sortColumn($event, 'shipToId', ordersList, 'normal')">
              {{ 'accountOrders.order_ship_to_label' | cxTranslate }}
              <em class="my-icon fas fa-caret-down"></em>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (data of ordersList; track data; let i = $index) {
            <tr>
              <td>
                <span>{{ data.placedDateObj | date: 'dd/MM/yyyy' }}</span>
              </td>
              <td>
                <a
                  [routerLink]="['/my-account/order', data.guid]"
                  href="javascript: void(0);">
                  {{ data.guid }}
                </a>
              </td>
              <td class="status-txt">
                <span>{{ data.statusDisplay }}</span>
              </td>
              <td>
                <span class="po-size">{{ data.purchaseOrderNumber }}</span>
              </td>
              <td>
                @if (!!data?.shipToName) {
                  <span>{{ data.shipToName }}</span>
                }
                @if (!!data?.shipToName) {
                  <br />
                }
                <span>{{ data.shipToId }}</span>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <table
        aria-describedby="ordersTable"
        id="applyOrdersTable"
        class="credits-table table table-striped">
        <tr class="sample-header">
          <th scope="col"></th>
          <th scope="col"></th>
        </tr>
        @for (data of ordersList; track data; let i = $index) {
          <tr>
            <td class="two-column-lay header">
              {{ 'accountOrders.date_label' | cxTranslate }}
            </td>
            <td class="two-column-lay">
              {{ data?.placedDateObj | date: 'dd/MM/yyyy' }}
            </td>
            <td class="two-column-lay header">
              {{ 'accountOrders.order_no_label' | cxTranslate }}
            </td>
            <td class="two-column-lay">
              <a
                [routerLink]="['/my-account/order', data?.guid]"
                href="javascript: void(0);">
                {{ data?.code }}
              </a>
            </td>
            <td class="two-column-lay header">
              {{ 'accountOrders.order_status_label' | cxTranslate }}
            </td>
            <td class="two-column-lay status-txt">{{ data?.statusDisplay }}</td>
            <td class="two-column-lay header">
              {{ 'accountOrders.order_po_num_label' | cxTranslate }}
            </td>
            <td
              class="two-column-lay po-size"
          [ngClass]="{
            'po-more-list':
              !!data?.purchaseOrderNumber &&
              data?.purchaseOrderNumber?.length > 20,
          }">
              {{ data?.purchaseOrderNumber }}
            </td>
            <td class="two-column-lay header">
              {{ 'accountOrders.order_ship_to_label' | cxTranslate }}
            </td>
            <td
              class="two-column-lay shipTo-height"
              [ngClass]="{ last: !!data?.shipToName === true }">
              @if (!!data?.shipToName) {
                <span>{{ data?.shipToName }}</span>
              }
              @if (!!data?.shipToName) {
                <br />
              }
              <span>{{ data?.shipToId }}</span>
            </td>
          </tr>
        }
      </table>
    </section>
  }
  <!--table ends-->
  @if (!!ordersList && ordersList.length > 0 && isLoadingDone) {
    <div
      class="invoice-btngrps"
      >
      <button
        type="button"
        class="btn btn-primary oi-blue-button btnpaymentinvoicecredit"
        data-di-id="di-id-41a05d18-6b04a424"
        [routerLink]="['/my-account/orders']">
        {{ 'accountOrders.button_text' | cxTranslate }}
      </button>
    </div>
  }
</div>
